// extracted by mini-css-extract-plugin
export default {"footer-partner--image-container":"footer-partner--image-container--2pyTs","footerPartnerImageContainer":"footer-partner--image-container--2pyTs"};